import { StackStatus } from "../../../services/backend_gateway/__generated__/backend_gateway-types";
import { UtilitiesComponent } from "./component";

export const UtilitiesContainer = (props: {
  deploymentId: string;
  navigateToHelp: (stepId: string) => void;
  utilitiesStackStatus: StackStatus | null;
}) => {
  const { deploymentId, utilitiesStackStatus } = props;

  return (
    <UtilitiesComponent
      loading={false}
      deploymentId={deploymentId}
      utilitiesStackStatus={utilitiesStackStatus?.status || null}
    />
  );
};
